import api from '@/api';
import {
  PortoBatteryWarrantyRequest,
  PortoBatteryWarrantyResponse,
} from './battery.types';

const CONTROLLER = '/porto/battery/warranty';

export default {
  async detail(params: PortoBatteryWarrantyRequest) {
    const result = (await api.get(CONTROLLER, params)) as unknown;
    return result as PortoBatteryWarrantyResponse;
  },
};
